function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.985 1.515a.5.5 0 01.058.638l-.058.07L3.907 10.3l3.09-.43a.5.5 0 01.544.339l.02.088a.5.5 0 01-.338.544l-.088.02-4.566.634-.012.002a.503.503 0 01-.043.003l.055-.005a.507.507 0 01-.372-.097.538.538 0 01-.05-.044l-.02-.02a.506.506 0 01-.028-.036l.047.056a.501.501 0 01-.146-.36v-.01c0-.02.003-.039.006-.058l.002-.015.828-4.566a.5.5 0 01.992.089l-.008.09-.543 2.99 8.001-7.999a.5.5 0 01.707 0z",
  fill: "#D24667",
  fillRule: "nonzero"
})));